import api from '@services/api'

export default {
  get(axios, params, query, config) {
    return api.get(axios, '/manager/machines/:machine_id/firmware', params, query, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/manager/machines/:machine_id/firmware', params, payload, config)
  },

  search(axios, params, query, config) {
    return api.get(axios, '/manager/machines/:machine_id/firmware/search', params, query, config)
  },
}
